import { isLoggedInVendorTeamMember } from "./teamMemberSelf";

/** Formats digits as 1-234-567-8900 (max 11 digits). */
export function formatUsPhoneInputValue(raw) {
  const digits = String(raw || "")
    .replace(/\D/g, "")
    .slice(0, 11);
  if (!digits) return "";
  const parts = [digits.slice(0, 1)];
  if (digits.length > 1) parts.push(digits.slice(1, 4));
  if (digits.length > 4) parts.push(digits.slice(4, 7));
  if (digits.length > 7) parts.push(digits.slice(7, 11));
  return parts.join("-");
}

export function findSelfTeamRow(items, clerkUserId, profileEmail) {
  const rows = Array.isArray(items) ? items : [];
  return (
    rows.find((row) => isLoggedInVendorTeamMember(row, clerkUserId)) ||
    rows.find(
      (row) =>
        row?.email &&
        profileEmail &&
        String(row.email).toLowerCase() === String(profileEmail).toLowerCase()
    ) ||
    null
  );
}

export function isSoleUserContactDesignationsReadOnly(teamUsersData) {
  const teamRosterLoaded = teamUsersData != null;
  return teamRosterLoaded && (teamUsersData?.items?.length ?? 0) <= 1;
}

export function extractProviderSubRoles(userDetails, selfTeamRow) {
  const fromMe =
    userDetails?.provider_user_subrole
      ?.map((r) => r?.subrole || r?.Subrole || (typeof r === "string" ? r : null))
      .filter(Boolean) || [];
  if (fromMe.length) return fromMe;
  if (Array.isArray(selfTeamRow?.sub_roles)) return selfTeamRow.sub_roles;
  return [];
}

export function extractProviderPermissions(userDetails, selfTeamRow) {
  const fromMe =
    userDetails?.provider_user_permissions
      ?.map((p) =>
        p?.permission || p?.Permission || (typeof p === "string" ? p : null)
      )
      .filter(Boolean) || [];
  if (fromMe.length) return fromMe;
  if (Array.isArray(selfTeamRow?.permissions)) return selfTeamRow.permissions;
  return [];
}

export function resolveProfileJobTitle(userDetails, selfTeamRow) {
  return (
    userDetails?.job_title ||
    selfTeamRow?.job_title ||
    selfTeamRow?.title ||
    ""
  );
}

export function buildLoggedInProfilePayload(data) {
  return {
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    job_title: (data.job_title ?? "").trim() || null,
    phone_number: data.phone_number,
    office_phone_number: data.office_phone_number,
    contact_preference: data.contact_preference,
  };
}

export function shouldApplyContactDesignations({
  contactDesignationsReadOnly,
  providerUserId,
  providerId,
  eligibleCategories,
}) {
  return (
    !contactDesignationsReadOnly &&
    !!providerUserId &&
    !!providerId &&
    (eligibleCategories?.length ?? 0) > 0
  );
}

export function soleUserContactDesignationReason(isSoleUserInOrg) {
  return isSoleUserInOrg
    ? "Your organization has only one user, so request contact designations cannot be changed."
    : undefined;
}
